import { customValidators } from "src/app/_helpers/customValidators";
import { Component, ElementRef, Input, OnInit } from "@angular/core";
import { FloorService } from "../floor/floor.service";
import {
  AlertController,
  LoadingController,
  ModalController,
} from "@ionic/angular";
import { Router } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { globalHelper } from "src/app/_helpers/global";
import { UserService } from "src/app/_services";
import { ThisPlatform } from "src/app/_services/platform.service";
import { Floor } from "../floor/floor.model";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { AttachmentImage } from "src/app/_models/image.model";

@Component({
  selector: "app-edit-floor",
  templateUrl: "./edit-floor.page.html",
  styleUrls: ["./edit-floor.page.scss", "./../../../_styles/ion-grid-box.scss"],
})
export class EditFloorPage implements OnInit {
  constructor(
    public router: Router,
    public floorServ: FloorService,
    public alertController: AlertController,
    public translateService: TranslateService,
    public loadingCtrl: LoadingController,
    private userServ: UserService,
    public p: ThisPlatform,
    public modalController: ModalController,
    private el: ElementRef
  ) {}

  permissionEditFloor = false;
  disableSaveButton: boolean = false;
  validationError: boolean = false;

  fileData: File = null;
  filePath: AttachmentImage = null;
  deleteAttachments = false;

  form: FormGroup;

  growAuto = false;
  @Input()
  buildingId: number;

  @Input()
  floorId: number;

  ngOnInit() {
    this.permissionEditFloor = this.userServ.hasRoles(["building.floor.edit"]);

    this.floorServ.floor = new Floor();

    this.initForm();

    if (this.floorId) {
      this.floorServ.getFloor(this.floorId).subscribe((floor: Floor) => {
        this.filePath = floor.floorPlan;
        this.loadFloor(floor);
      });
    }
  }

  initForm() {
    this.form = new FormGroup({
      name: new FormControl(null, {
        updateOn: "blur",
        validators: [Validators.required, customValidators.trimValidator()],
      }),
      description: new FormControl(null, {
        updateOn: "blur",
        validators: Validators.required,
      }),
      level: new FormControl(null, {
        updateOn: "blur",
        validators: [
          Validators.required, 
          customValidators.inRange(-10, 99),
          customValidators.isFloat(),
        ],
      }),
      itemImage: new FormControl("", {
        updateOn: "blur",
        validators: [
          customValidators.fileMaxSize(10000000),
          customValidators.fileFormat([
            "jpg",
            "png",
            "gif",
            "jfif",
            "pjpeg",
            "jpeg",
            "pjp",
          ]),
        ],
      }),
    });
  }

  imageUploaded(file: File) {
    this.deleteAttachments = false;
    this.fileData = file;
  }

  imageRemoved($event) {
    this.deleteAttachments = true;
    this.fileData = null;
  }

  loadFloor(floor) {
    this.form.patchValue({
      name: floor.name,
      description: floor.description,
      level: floor.level,
      file: floor.floorPlan,
    });
  }

  Save() {
    if (!this.form.valid) {
      this.validationError = true;
      globalHelper.scrollToFirstInvalidControl(this.el);
      return;
    }
    const form = this.form.value;

    this.disableSaveButton = true;

    const formData = new FormData();

    formData.append("name", form.name ? form.name : "");
    formData.append("description", form.description ? form.description : "");
    formData.append("level", form.level ? form.level.toString() : "");
    this.fileData ? formData.append("file", this.fileData) : "";

    if (this.deleteAttachments) {
      formData.append("deleteAttachments", JSON.stringify(true));
    }

    if (this.floorId) {
      this.floorServ
        .updateFloor(this.buildingId, this.floorId, formData)
        .subscribe((res) => {
          this.close();
          this.disableSaveButton = true;
        });
    } else {
      this.floorServ.addFloor(this.buildingId, formData).subscribe((res) => {
        this.close();
        this.disableSaveButton = true;
      });
    }
  }

  async deleteFloor() {
    let confirm = await globalHelper.Alert(
      this.alertController,
      this.translateService
    );

    if (confirm) {
      this.loadingCtrl
        .create({
          keyboardClose: true,
          message: this.translateService.instant("DELETING"),
        })
        .then((loadingEl) => {
          loadingEl.present();
          this.floorServ.deleteFloor(this.floorId).subscribe((res) => {
            this.close();
            loadingEl.dismiss();
          });
        });
    }
  }

  onInput() {
    this.growAuto = true;
  }

  close() {
    this.modalController.dismiss();
  }
}
